import React from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../Common/Header';
import Modal from 'react-bootstrap/Modal';
import ToggleButton from "react-bootstrap/ToggleButton";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import axios from 'axios';
import DatePicker from "react-datepicker";
import OwntransferPage from "./MakePayments/OwnTransfer";
import TrirdpartyPage from "./MakePayments/ThirdPartyTransfer";
import ScheduledTransferPage from "./MakePayments/ScheduledTransfer";
import TransferHistoryPage from "./MakePayments/TransferHistory";
import DailyLimitPage from "./MakePayments/DailyTransferLimit";
import EditTrnsRecipientPage from "./MakePayments/MaintainTransferRecipient"
import StandingOrdersPage from "./StandingOrders/StandingOrder"
import ActiveStoPage from "./StandingOrders/ActiveSTO"
import StoHistoryPage from "./StandingOrders/StoHistory"
import StoRemoveRecipientPage from "./StandingOrders/RemoveStoRecipient"
import BillRegisterPage from "./BillPayments/BillRegister"
import BillPaymentPage from "./BillPayments/BillPayment"
import ActiveBillPaymentPage from "./BillPayments/ActiveBillPayments"
import BillHistoryPage from "./BillPayments/BillHistory"
import BillRemovePage from "./BillPayments/BillRemoveRecipient"
import SavingsDetailPage from "./MakePayments/SavingsDetails"
import FadeLoader from "react-spinners/HashLoader";
import Common from '../Common/CommonAPI';
import "react-datepicker/dist/react-datepicker.css";
import Switch from "react-switch";

import transferImage from "../images/transfer.png"
import transferImage2 from "../images/transfero.png"
import ttransferImage from "../images/ttransfer.png"
import ttransferImage2 from "../images/ttransfero.png"
import stransferImage from "../images/stransfer.png"
import stransferImage2 from "../images/stransfero.png"
import htransferImage from "../images/htransfer.png"
import htransferImage2 from "../images/htransfero.png"
import mtransferImage from "../images/mtransfer.png"
import mtransferImage2 from "../images/mtransfero.png"
import mrecipient from "../images/mrecipient.png"
import mrecipient2 from "../images/mrecipiento.png"
import stotransfer from "../images/stotransfer.png"
import stotransfer2 from "../images/stotransfero.png"
import stohistry from "../images/stohisty.png"
import stohistry2 from "../images/stohistyo.png"
import billreg from "../images/billreg.png"
import billreg2 from "../images/billrego.png"
import billtransfer from "../images/billcreate.png"
import billtransfer2 from "../images/billcreateo.png"
import billactv from "../images/billactv.png"
import billactv2 from "../images/billactvo.png"
import hbill from "../images/hbill.png"
import mbill from "../images/mbill.png"

var api = require('../Common/Config');
var JOINT_HOLDER = 'api/updateUserVisibility';

class SavingsHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            arrayVal: [],
            username: '',
            ActiveSto: false,
            ActiveStoDetailModal: false,
            StoHistoryDetailsModal: false,
            owntrnsferModal: false,
            ThirdTrnsferModal: false,
            ScheduleTransferModal: false,
            TransferHistoryModal: false,
            TransferLimitModal: false,
            EditTrnsRecipientModal: false,
            StandingOrderModal: false,
            StoHistoryModal: false,
            StoRemoveRecipientModal: false,
            MySavingsPage: true,
            SavingsDetail: false,
            BillRegisterModal: false,
            BillPaymentModal: false,
            ActiveBill: false,
            BillHistoryModal: false,
            BillRemoveModal: false,
            OwnScheduleDate: new Date(),
            ThirdScheduleDate: new Date(),
            StoStartDate: new Date(),
            StoEndDate: new Date(),
            BillStartDate: new Date(),
            BillEndDate: new Date(),
            SavingsAccount: [],
            currentBalTotal: 0,
            avialableBalTotal: 0,
            totalPendingTransaction: 0,
            unrealizedFundTotal: 0,
            Loading: true,
            mouseOver1:0,

        }
        this.handlejointHolder = this.handlejointHolder.bind(this);
    }



    componentDidMount() {
        this.homeAPI();
    }
    async handlejointHolder(checked) {

        this.setState({ jointHandler: checked, Loading: true });

        await axios({
            method: "POST",
            url: api.HOST + JOINT_HOLDER,
            data: {
                "userVisibility": checked,
            },
            headers: {
                'Authorization': `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
                'Content-Type': 'application/json'
            }
        }).then((responses) => {
            if (responses.status >= 200 && responses.status < 300) {
                return responses;
            }
        })
            .then((results) => {
                if (results.data.message === "Success") {
                    this.homeAPI();
                }
                return results.data
            })
            .catch((err) => {
                return err;
            })
            .finally(() => {
                //this.setState({showProgress:false});
            });
    }
    ResponseLoadingModal() {
        return (
            <Modal
                size="lg"
                centered
                className="ui-block" show={this.state.Loading}>
                <FadeLoader
                    height={25}
                    width={5}
                    radius={2}
                    margin={2}
                    color={"#197b55"}
                    size={"80px"} this also works
                    loading={this.state.Loading}
                />

            </Modal>
        )
    }

    homeAPI() {
        Common.SavingsAccounts((results) => {

            this.setState(Object.assign({
                showProgress: results.success ? true : false,
                //isLogin:true,
                Loading: false,
            }, results));
            if (results) {
                if (results.message === " No Result Found") {
                    this.setState({
                        dataSource: [],
                        Loading: false,
                    });
                    return console.log("No Result Found");
                }
                this.setState({
                    SavingsAccount: results.mapAccountList,
                    jointHandler: results.mapAccountList.filter(e => e.jointAccountVisibility === false).length > 0 ? false : true,
                    accountMode: results.mapAccountList.filter(e => e.accountMode === "Joint").length > 0 ? true : false,
                    TotalAmount: results.currentBalance,
                    currentBalTotal: results.currentBalTotal,
                    avialableBalTotal: results.avialableBalTotal,
                    unrealizedFundTotal: results.unrealizedFundTotal,
                    totalPendingTransaction: results.totalPendingTransaction,
                    Loading: false,

                });
            }
        });
    }

    OwntoggleModal = () => {
        this.setState({ owntrnsferModal: !this.state.owntrnsferModal })
    }
    OwnslectedDate = (e) => {
        this.setState({ OwnScheduleDate: e });
    }

    TrirdToggleModal = () => {
        this.setState({ ThirdTrnsferModal: !this.state.ThirdTrnsferModal })
    }
    TrirdSelectedDate = (e) => {
        this.setState({ ThirdScheduleDate: e });
    }
    StoStartSelectedDate = (e) => {
        this.setState({ StoStartDate: e });
    }
    StoEndSelectedDate = (e) => {
        this.setState({ StoEndDate: e });
    }

    BillStartSelectedDate = (e) => {
        this.setState({ BillStartDate: e });
    }
    BillEndSelectedDate = (e) => {
        this.setState({ BillEndDate: e });
    }

    TransferLimitToggleModal = () => {
        this.setState({ TransferLimitModal: !this.state.TransferLimitModal })
    }
    EditTrnsRecipientToggleModal = () => {
        this.setState({ EditTrnsRecipientModal: !this.state.EditTrnsRecipientModal })
    }

    StandingOrderToggleModal = () => {
        this.setState({ StandingOrderModal: !this.state.StandingOrderModal })
    }

    StoHistoryToggleModal = () => {
        this.setState({ StoHistoryModal: !this.state.StoHistoryModal })
    }
    StoremoverecipientToggleModal = () => {
        this.setState({ StoRemoveRecipientModal: !this.state.StoRemoveRecipientModal })
    }
    BillPaymentToggleModal = () => {
        this.setState({ BillPaymentModal: !this.state.BillPaymentModal })
    }
    BillRegisterToggleModal = () => {
        this.setState({ BillRegisterModal: !this.state.BillRegisterModal })
    }

    BillRemoveToggleModal = () => {
        this.setState({ BillRemoveModal: !this.state.BillRemoveModal })
    }

    ActiveStoDetailsToggleModal = () => {
        this.setState({ ActiveStoDetailModal: !this.state.ActiveStoDetailModal })
    }
    StoHistoryDetailsToggleModal = () => {
        this.setState({ StoHistoryDetailsModal: !this.state.StoHistoryDetailsModal })
    }

    SaveSavingsDetails = (ind) => {
        var SaveAccId = {
            savAccDetails: ind,
        }
        var value = JSON.stringify(SaveAccId);
        sessionStorage.setItem('SavingsValue', value);
        this.setState({ SavingsDetail: true })
    }
    // rowClick = (ind)=>{
    //     var i =ind+1;
    //     this.state.SavingsAccount.unshift(this.state.SavingsAccount[ind])
    //     this.state.SavingsAccount.splice(ind+1,1)
    //     this.forceUpdate()        
    // }

    render() {

        return (
            <div>
                {this.ResponseLoadingModal()}
                {this.state.owntrnsferModal ?
                    <OwntransferPage isOpen={this.state.owntrnsferModal} toggle={this.OwntoggleModal}
                        scheduledDate={this.state.OwnScheduleDate} selectDate={this.OwnslectedDate} />
                    : null}
                {this.state.ThirdTrnsferModal ?
                    <TrirdpartyPage isOpen={this.state.ThirdTrnsferModal} toggle={this.TrirdToggleModal}
                        scheduledDate={this.state.ThirdScheduleDate} selectDate={this.TrirdSelectedDate} />
                    : null}
                {this.state.TransferLimitModal ?
                    <DailyLimitPage isOpen={this.state.TransferLimitModal} toggle={this.TransferLimitToggleModal} />
                    : null}

                {this.state.EditTrnsRecipientModal ?
                    <EditTrnsRecipientPage isOpen={this.state.EditTrnsRecipientModal} toggle={this.EditTrnsRecipientToggleModal} />
                    : null}
                {this.state.StandingOrderModal ?
                    <StandingOrdersPage isOpen={this.state.StandingOrderModal} toggle={this.StandingOrderToggleModal}
                        scheduledDate={this.state.StoStartDate} selectDate={this.StoStartSelectedDate}
                        scheduledDate2={this.state.StoEndDate} selectDate2={this.StoEndSelectedDate} />
                    : null}
                {this.state.StoRemoveRecipientModal ?
                    <StoRemoveRecipientPage isOpen={this.state.StoRemoveRecipientModal} toggle={this.StoremoverecipientToggleModal} />
                    : null}
                {this.state.BillRegisterModal ?
                    <BillRegisterPage isOpen={this.state.BillRegisterModal} toggle={this.BillRegisterToggleModal} />
                    : null}
                {this.state.BillPaymentModal ?
                    <BillPaymentPage isOpen={this.state.BillPaymentModal} toggle={this.BillPaymentToggleModal}
                        scheduledDate={this.state.BillStartDate} selectDate={this.BillStartSelectedDate}
                        scheduledDate2={this.state.BillEndDate} selectDate2={this.BillEndSelectedDate} />
                    : null}
                {this.state.BillRemoveModal ?
                    <BillRemovePage isOpen={this.state.BillRemoveModal} toggle={this.BillRemoveToggleModal} />
                    : null}
                {/* <Header saveonclick={() => this.setState({
                    MySavingsPage: true, ActiveSto: false,
                    ActiveBill: false, SavingsDetail: false, StoHistoryModal: false,
                    ScheduleTransferModal: false, TransferHistoryModal: false, BillHistoryModal: false
                })}
                    fdonclick={() => this.setState({})} /> */}

                <Container fluid>
                    <Row>
                        <Col className='p-0'>
                            <section className='b-color mb-3'>
                            <Container>
                            <Row className='mobile-gut'>
                                <Col lg={4} className='rmv-pad text-color block vl2' >
                                    <Row className=''>
                                        <p className='t-left fontSize'>
                                            <h5> TRANSFER FUNDS</h5>
                                        </p>
                                    </Row>

                                    <Row className=''>
                                        <div className='t-left fontSize'>
                                            <Button 
                                            onMouseOver={()=>this.setState({mouseOver1:1})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})}
                                            onClick={() => this.setState({ owntrnsferModal: true, ActiveBill: false, ActiveSto: false })} 
                                            className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===1?transferImage2:transferImage} />
                                                    <p className='hbuttonfont'>OWN ACCOUNT TRANSFERS</p>
                                                </div>
                                            </Button>
                                            <Button 
                                            onMouseOver={()=>this.setState({mouseOver1:2})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})}
                                            onClick={() => this.setState({ ThirdTrnsferModal: true, ActiveBill: false, ActiveSto: false })} 
                                            className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===2?ttransferImage2:ttransferImage} />
                                                    <p className='hbuttonfont'>THIRD PARTY TRANSFERS</p>
                                                </div>
                                            </Button>
                                            <Button 
                                            onMouseOver={()=>this.setState({mouseOver1:3})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})}
                                            onClick={() => this.setState({ ScheduleTransferModal: true, TransferHistoryModal: false, ActiveBill: false, ActiveSto: false })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===3?stransferImage2:stransferImage} />
                                                    <p className='hbuttonfont'>VIEW SCHEDULED TRANSFERS</p>
                                                </div>
                                            </Button>
                                            <Button
                                            onMouseOver={()=>this.setState({mouseOver1:4})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})}
                                             onClick={() => this.setState({ TransferHistoryModal: true, ScheduleTransferModal: false, ActiveBill: false, ActiveSto: false })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===4?stohistry2:stohistry} />
                                                    <p className='hbuttonfont'>VIEW TRANSFER HISTORY</p>
                                                </div>
                                            </Button>
                                            <Button
                                            onMouseOver={()=>this.setState({mouseOver1:5})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})} 
                                            onClick={() => this.setState({ TransferLimitModal: true, ActiveBill: false, ActiveSto: false })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===5?mtransferImage2:mtransferImage} />
                                                    <p className='hbuttonfont'>EDIT TRANSACTION LIMITS</p>
                                                </div>
                                            </Button>
                                            <Button 
                                            onMouseOver={()=>this.setState({mouseOver1:6})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})} 
                                            onClick={() => this.setState({ EditTrnsRecipientModal: true, ActiveBill: false, ActiveSto: false })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===6?mrecipient2:mrecipient} />
                                                    <p className='hbuttonfont'>EDIT <br />PAYEES</p>
                                                </div>
                                            </Button>
                                        </div>
                                    </Row>
                                </Col>
                                <Col lg={4} className='rmv-pad text-color block vl' >
                                    <Row className=''>
                                        <p className='t-left fontSize'>
                                            <h5> STANDING ORDERS</h5>
                                        </p>
                                    </Row>
                                    <Row className=''>
                                        <div className='t-left fontSize'>
                                            <Button
                                             onMouseOver={()=>this.setState({mouseOver1:7})}
                                             onMouseOut={()=>this.setState({mouseOver1:0})}  
                                            onClick={() => this.setState({ StandingOrderModal: true, ActiveBill: false, })}                                             
                                            className="home-btn" variant="primary" type="submit">
                                                <div  >
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===7?stotransfer2:stotransfer} 
                                                    />
                                                    <p className='hbuttonfont'>CREATE STANDING ORDERS</p>
                                                </div>
                                            </Button>
                                            <Button 
                                             onMouseOver={()=>this.setState({mouseOver1:8})}
                                             onMouseOut={()=>this.setState({mouseOver1:0})} 
                                            onClick={() => this.setState({ ActiveSto: true, ActiveBill: false, })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===8?htransferImage2:htransferImage} />
                                                    <p className='hbuttonfont'>VIEW ACTIVE STANDING ORDERS</p>
                                                </div>
                                            </Button>
                                            <Button
                                             onMouseOver={()=>this.setState({mouseOver1:9})}
                                             onMouseOut={()=>this.setState({mouseOver1:0})}
                                                onClick={() => this.setState({
                                                    StoHistoryModal: true, ThirdTrnsferModal: false,
                                                    ActiveBill: false, ScheduleTransferModal: false, BillHistoryModal:false,TransferHistoryModal: false, ActiveSto: false
                                                })}
                                                className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===9?stohistry2:stohistry} />
                                                    <p className='hbuttonfont'>STANDING ORDERS HISTORY</p>
                                                </div>
                                            </Button>
                                            <Button
                                            onMouseOver={()=>this.setState({mouseOver1:10})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})}
                                            onClick={() => this.setState({ StoRemoveRecipientModal: true, ActiveBill: false, ActiveSto: false })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===10?mrecipient2:mrecipient} />
                                                    <p className='hbuttonfont'>REMOVE STANDING ORDER PAYEES</p>
                                                </div>
                                            </Button>

                                        </div>
                                    </Row>
                                </Col>

                                <Col lg={4} className='rmv-pad text-color block vl' >
                                    <Row className=''>
                                        <p className='t-left fontSize'>
                                            <h5>UTILITY / BILL PAYMENTS</h5>
                                        </p>
                                    </Row>
                                    <Row className=''>
                                        <div className='t-left fontSize'>
                                            <Button 
                                             onMouseOver={()=>this.setState({mouseOver1:11})}
                                             onMouseOut={()=>this.setState({mouseOver1:0})}
                                            onClick={() => this.setState({ BillRegisterModal: true, ActiveBill: false, ActiveSto: false })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===11?billreg2:billreg} />
                                                    <p className='hbuttonfont'>BILL<br /> REGISTER</p>
                                                </div>
                                            </Button>
                                            <Button
                                            onMouseOver={()=>this.setState({mouseOver1:12})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})}
                                             onClick={() => this.setState({ BillPaymentModal: true, ActiveBill: false, ActiveSto: false })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===12?billtransfer2:billtransfer} />
                                                    <p className='hbuttonfont'>MAKE BILL PAYMENTS</p>
                                                </div>
                                            </Button>
                                            <Button
                                            onMouseOver={()=>this.setState({mouseOver1:13})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})}
                                             onClick={() => this.setState({ ActiveBill: true, StoHistoryModal: false, ActiveSto: false, ScheduleTransferModal: false, SavingsDetail: false,TransferHistoryModal: false, })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===13?billactv2:billactv} />
                                                    <p className='hbuttonfont'>ACTIVE BILL PAYMENTS</p>
                                                </div>
                                            </Button>
                                            <Button
                                            onMouseOver={()=>this.setState({mouseOver1:14})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})}
                                             onClick={() => this.setState({ BillHistoryModal: true,  StoHistoryModal: false,ScheduleTransferModal: false, TransferHistoryModal: false, ActiveBill: false,SavingsDetail: false, ActiveSto: false })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===14?stohistry2:stohistry} />
                                                    <p className='hbuttonfont'>BILL PAYMENT HISTORY</p>
                                                </div>
                                            </Button>
                                            <Button
                                            onMouseOver={()=>this.setState({mouseOver1:15})}
                                            onMouseOut={()=>this.setState({mouseOver1:0})}
                                            onClick={() => this.setState({ BillRemoveModal: true, ScheduleTransferModal: false, TransferHistoryModal: false, ActiveBill: false, ActiveSto: false })} className="home-btn" variant="primary" type="submit">
                                                <div>
                                                    <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===15?mrecipient2:mrecipient} />
                                                    <p className='hbuttonfont'>REMOVE BILL PAYMENT</p>
                                                </div>
                                            </Button>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                            </Container>
                            </section>
                            <Container >
                            {this.state.ActiveSto ?
                                <ActiveStoPage popup={() => this.setState({ ActiveStoDetailModal: true })}
                                />
                                : this.state.ScheduleTransferModal ?
                                <ScheduledTransferPage />
                                : this.state.TransferHistoryModal ?
                                <TransferHistoryPage />
                                : this.state.StoHistoryModal ?
                                <StoHistoryPage />
                                : this.state.ActiveBill ?
                                <ActiveBillPaymentPage />
                                : this.state.SavingsDetail ?
                                <SavingsDetailPage />
                                : this.state.BillHistoryModal ?
                                <BillHistoryPage  />
                                : this.state.MySavingsPage ?
                            <div>
                                <Row lg={12} className="block">
                                    <Col lg={3} className='rmv-pad' >
                                        <div className='d-box'>
                                            <p className='t-right fontSize'>
                                                Current Balance<br />
                                                <h2>{this.state.currentBalTotal?this.state.currentBalTotal.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):"0.00"}</h2>
                                                LKR
                                            </p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='rmv-pad2'>
                                        <div className='d-box d-box1'>
                                            <p className='t-right fontSize'>
                                                Total Available Balance<br />
                                                <h2>{this.state.avialableBalTotal?this.state.avialableBalTotal.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):"0.00"}</h2>
                                                LKR
                                            </p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='rmv-pad2'>
                                        <div className='d-box d-box2'>
                                            <p className='t-right fontSize'>
                                                Pending Transactions / Holds<br />
                                                <h2>{this.state.totalPendingTransaction?this.state.totalPendingTransaction.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):"0.00"}</h2>
                                                LKR
                                            </p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='rmv-pad3'>
                                        <div className='d-box d-box3'>
                                            <p className='t-right fontSize'>
                                                Unrealized Cheques<br />
                                                <h2>{this.state.unrealizedFundTotal?this.state.unrealizedFundTotal.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):"0.00"}</h2>
                                                LKR
                                            </p>
                                        </div>
                                    </Col>
                                </Row>

                                <Row lg={12}>
                                        {/* {this.state.accountMode ?
                                            <div className="d-flex flex-row justify-content-end">
                                                <p >Enable Joint Accounts</p>
                                                <Switch
                                                    onChange={this.handlejointHolder}
                                                    checked={this.state.jointHandler}
                                                    onColor="#05b083"
                                                    className='switch'
                                                />
                                            </div>
                                        : null} */}
                                    <Col lg={12} className='table-padding block  text-color'>
                                    <Table  hover  striped responsive>
                                        <thead  >
                                            <tr  className='tr'>
                                            <th className='t-left'>No</th>
                                            <th className='t-left'>Account No</th>
                                            <th className='t-right'>Current Balance LKR</th>
                                            <th className='t-right'>Available Balance LKR</th>
                                            <th className='t-right'>Unrealized Cheques LKR</th>
                                            <th className='t-right'></th>
                                            </tr>
                                        </thead>
                                        <tbody >                                                                    
                                            {this.state.SavingsAccount ?
                                                this.state.SavingsAccount.filter((e) => (e.jointAccountVisibility === true)).map((listValue, index) => {
                                                    return (                                                        
                                                        <tr  className='tr-h' >
                                                            <td className='t-left'>{index + 1}</td>
                                                            <td className='t-left'>{listValue.accountNo}</td>
                                                            <td className='t-right'>{listValue.currentBalance ? listValue.currentBalance.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00"}</td>
                                                            <td className='t-right'>{listValue.avialableBalance ? listValue.avialableBalance.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00"}</td>
                                                            <td className='t-right'>{listValue.unrealizedFund ? listValue.unrealizedFund.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00"}</td>
                                                            <td className='t-right'>
                                                            <Button                                                           
                                                            onClick={() => this.SaveSavingsDetails(listValue)}
                                                             className='btn-browse'  type="submit">
                                                                Details
                                                            </Button>
                                                            </td>
                                                        </tr>
                                                        // <Row onClick={()=>{this.rowClick(index)}}  className='tablebody1' >
                                                        
                                                    );
                                                }) : null
                                            }  
                                                                                     
                                        </tbody>
                                    </Table>                                  
                                    </Col>
                                </Row>
                            </div>
                            : null
                            }
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}
export default SavingsHome;